"use client";

import { useTranslations } from "next-intl";
import { brandConfig } from "@/config/brand";

export function ContactFormNoScript() {
	const t = useTranslations("footer.inquiry");

	return (
		<noscript>
			<p className="mt-4 text-sm text-muted-foreground">
				{t("formRequiresJavaScript")}{" "}
				<a href={`mailto:${brandConfig.supportEmail}`} className="break-all text-primary underline">
					{brandConfig.supportEmail}
				</a>
			</p>
		</noscript>
	);
}
